<!-- Copyright: Seán I. O'Donoghue -->

<template>
  <div v-if="showBanner" class="access-banner" @click="$router.push({hash: '#sign-in'})">
    <span>To access the full VIZBI video library, register for the VIZBI {{ currentYear }} Masterclass and Workshop.</span>
    <button class="learn-more" @click.stop="$router.push({name: 'Videos_Unlock'})">Learn more</button>
  </div>
</template>

<script setup>
import {getVideoAccessNow} from "@/composables/videoAccessNow";
import {computed} from "vue";
import useUserSafe from "@/composables/useUserSafe";

const {user} = useUserSafe();
const currentYear = new Date().getFullYear();

const showBanner = computed(() => {
  if (!user.value) return false;
  const videoAccess = getVideoAccessNow(user.value?.publicMetadata?.videoAccess);
  const hasWorkshop = (videoAccess.workshopVideosUntil || 0) >= currentYear;
  const hasMasterclass = (videoAccess.masterclassVideosUntil || 0) >= currentYear;
  return !(hasWorkshop && hasMasterclass);
});
</script>

<style scoped>
.access-banner {
  background: #e07020;
  color: #fff;
  padding: 0.5rem 1rem;
  font-size: 0.95rem;
  text-align: center;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  margin-top: 0.5rem;
}
.learn-more {
  background: rgba(255, 255, 255, 0.25);
  border: 1px solid rgba(255, 255, 255, 0.6);
  color: #fff;
  border-radius: 4px;
  padding: 0.1rem 0.5rem;
  font-size: 0.9rem;
  cursor: pointer;
  white-space: nowrap;
}
</style>
